export default function BrandLogo({ variant = "mark", className = "", height = 28, compact = false }) {
  if (variant === "full") {
    return (
      <span className={`inline-flex ${className}`} data-testid="brand-logo-full">
        <img src="/brand/logo-light.png" alt="PointControl" className="logo-on-light w-auto" style={{ height }} />
        <img src="/brand/logo-dark.png" alt="PointControl" className="logo-on-dark w-auto" style={{ height }} />
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img src="/brand/mark-light.png" alt="" className="logo-on-light w-auto" style={{ height }} />
      <img src="/brand/mark-dark.png" alt="" className="logo-on-dark w-auto" style={{ height }} />
      <span className={`brand-word ${compact ? "hidden sm:inline" : ""}`} style={{ fontSize: height * 0.6 }}>POINT<span className="brand-lime">CONTROL</span></span>
    </span>
  );
}
